<template>
  <div class="custompagination">
    <vue-awesome-paginate
      v-model="currentPage"
      :total-items="totalRows"
      :items-per-page="perPage"
      :max-pages-shown="visiblePageButtons"
      :show-breakpoint-buttons="true"
      @click="$emit('update:modelValue', $event)"
    >
      <template #prev-button>
        <span>
          <UilAngleLeftB />
        </span>
      </template>

      <template #next-button>
        <span>
          <UilAngleRightB />
        </span>
      </template>
    </vue-awesome-paginate>
  </div>
</template>

<script>
import { UilAngleLeftB, UilAngleRightB } from "@lde/vue-unicons";
import { defineComponent } from "vue";

/**
 * Affiche une pagination sous forme de numéros avec navigation.
 */
export default defineComponent({
  name: "Pagination",
  components: { UilAngleLeftB, UilAngleRightB },
  props: {
    /**
     * Nombre total de ligne(s) dans le tableau.
     */
    totalRows: {
      type: Number,
      default: 10,
    },
    /**
     * Nombre maximum de boutons (numéros de page) à afficher.
     */
    visiblePageButtons: {
      type: Number,
      default: 5,
    },
    /**
     * Nombre par page.
     */
    perPage: {
      type: Number,
      default: 20,
    },
    /**
     * Identifiant HTML de l'ancre à atteindre au changement de page.
     */
    anchor: {
      type: String,
      default: "",
    },
  },
  emits: [
    /**
     * Déclenché lors d'un changement de page.
     * @param {Number} value Nouvelle page.
     */
    "update:modelValue",
  ],
  data() {
    return {
      currentPage: 1,
    };
  },
});
</script>

<style lang="scss">
@use "../../assets/styles/components/nav/pagination.scss";
</style>
